<template>
  <div class="pbc-component-condensed">
      <div v-if='!disableIcon' class="pbc-component-type-header">
        <div class="pbc-component-type-icon-parent">
          <component :is='icon' :size='iconSize' class="pbc-component-type-icon" />
        </div>
        <div class="pbc-component-type-name">{{dbentry.text}}</div>
      </div>
      <div v-if='component.quickAnimate' class="flex items-center justify-start overflow-hidden w-full">
        <div v-for='quickTween in component.tweens' :key='quickTween.name' :class='tagClasses'>
          {{quickTween.name}}
        </div>
      </div>
      <property-form v-else :condensed='true' :model='component' :transform='transform' :schema="dataSchema" :partutil="partutil" :transforms-and-source="transformsAndSource" class='text-black overflow-hidden w-20' />
  </div>
</template>
<script>
// This file is auto-generated
import CondensedComponentMixin from '@components/condensedComponentMixin.js';
import ComponentCondensedEditButton from '@ui/atoms/ComponentCondensedEditButton.vue';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import AnimationPlay from '@icons/AnimationPlay.vue';
export default {
  mixins: [CondensedComponentMixin],
  computed: {
    tagClasses() {
      const classes = ["flex-none text-gray-800 m-1 p-1 text-xs font-semibold rounded border border-gray-400 bg-green-300"];
      return classes;
    }
  },
  components:{
    ComponentCondensedEditButton
  }
}

</script>
